import React from "react";

interface Props {
  children: React.ReactNode;
}
export default function BulkActionBar({ children }: Props) {
  return (
    <div className="h-16 p-3 w-full bg-blue-800 rounded-lg justify-between items-center inline-flex text-white text-sm">
      {children}
    </div>
  );
}
